import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { ApiErrorResponse, ApiServiceInterface } from '@hutsix/ngxh6';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ForgotPasswordComponent implements OnDestroy {
    private unsubscribe$ = new Subject<void>();

    public form: { email: string | null } = { email: null };
    public submitted = false;
    public loading = false;
    public error?: string;

    constructor(
        @Inject('ApiService') private api: ApiServiceInterface,
        private cdRef: ChangeDetectorRef,
    ) {}

    public doRequest(): void {
        this.loading = true;
        this.error = undefined;
        this.api.post({ url: '/api/user/reset-request', data: this.form, skipAuth: true }).subscribe(
            () => {
                this.submitted = true;
                this.loading = false;
                this.cdRef.detectChanges();
            },
            (err: ApiErrorResponse<any>) => {
                this.loading = false;
                this.error = err.error?.error ? `${err.error.error.code} ${err.error.error.message}` : (err.error?.message ?? 'Something went wrong. Please try again.');
                this.cdRef.detectChanges();
            },
        );
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
